<div class="container">
  <h5>{{'DEVICE_SEARCH_TITLE'|translate}}
    <button type="button" class="btn btn-link" (click)="toggleInfoTextCollapse()"
      [attr.aria-expanded]="!isCollapsedInfoText" aria-controls="collapseExample">
      <span *ngIf="isCollapsedInfoText" class="oi oi-plus" title="icon plus" aria-hidden="true"></span>
      <span *ngIf="!isCollapsedInfoText" class="oi oi-minus" title="icon minus" aria-hidden="true"></span>
    </button>
  </h5>
  <p [ngbCollapse]="isCollapsedInfoText">{{'DEVICE_SEARCH_INFO'|translate}}</p>
</div>

<div class="container">

  <div appAccordion>

    <div [id]="accordionSearchPanel" [expanded]='true' appAccordionElement>

      <div appAccordionElementHeader>
        <button type="button" appAccordionElementTrigger>{{'SEARCH'|translate}}</button>
      </div>

      <app-accordion-element-body>

        <div class="card-body">

          <form [formGroup]="searchFormGroup">

            <!-- number, date and availability part of searchFormGroup -->
            <app-main-search-input [searchForm]="searchFormGroup" [numberCaption]="'DEVICENUMBER'|translate"
              [numberSubCaption]="'DEVICENUMBER_SUB'|translate"
              [checkboxCaption]="'SHOW_ONLY_AVAILABLE_DEVICES'|translate"></app-main-search-input>

            <!-- buttons -->
            <div class="row mt-4">
              <div class="col">
                <div class="float-right">
                  <button type="button" [disabled]="!searchFormGroup.valid" (click)="onSearchClick()"
                    class="btn btn-primary">{{'BTN_SEARCH'|translate}}</button>
                </div>
              </div>
            </div>

          </form>

          <!-- fixme -->
          <!-- <pre>{{searchFormGroup.value|json}}</pre> -->

        </div>

      </app-accordion-element-body>
    </div>

    <div [id]="accordionResultPanel" appAccordionElement>

      <div appAccordionElementHeader>
        <button type="button" appAccordionElementTrigger>{{'RESULT'|translate}}</button>
      </div>

      <app-accordion-element-body>
        <app-room-allocation-table [useReservationMode]="true" [model]="allocationTableModel"
          [currentDate]="currentDate" [isLoading]="isLoading" [type]="resourceType"
          [emptyResultMessage]="'NO_DEVICES_FOUND'|translate" (createReservation)="onCreateReservation($event)"
          (navigateDate)="onNavigateDate($event)" (openSchedule)="onOpenSchedule($event)"
          timespanConflictMessageKey="DEVICE_TIMELINE_OCCUPIED">
        </app-room-allocation-table>
      </app-accordion-element-body>
    </div>

  </div>
</div>

<!-- Reservation Dialog -->
<app-modal-dialog #createReservationDialog title="{{'CREATE_DEVICE_RESERVATION'|translate}}"
  [body]="modalCreateReservation" [showPositive]="false" [showCancel]="false" cancelButton="{{'CLOSE'|translate}}"
  size="lg"></app-modal-dialog>

<ng-template #modalCreateReservation>
  <app-messages></app-messages>
  <app-create-device-reservation-dialog [params]="createReservationParams" (saved)="onReservationSaved($event)">
  </app-create-device-reservation-dialog>
</ng-template>

<!-- Room Schedule Dialog -->
<app-modal-dialog #roomScheduleDialog title="{{'DEVICE_CALENDAR'|translate}}" [body]="modalRoomSchedule"
  [showPositive]="false" cancelButton="{{'CLOSE'|translate}}" size="lg"></app-modal-dialog>

<ng-template #modalRoomSchedule>
  <app-room-schedule [ressourceInfo]="activeRessourceInfo" [roomId]="activeItemId" [currentDate]="currentDate"
    [type]="resourceType" (createReservation)="onCreateReservation($event)"></app-room-schedule>
</ng-template>

<app-spinner-overlay></app-spinner-overlay>